import type { ConfigType } from './appConfig';

/** Use the rollout endpoint only in environments that explicitly configure one. */
export function resolveTradingApi(
    config: Pick<ConfigType, 'tradingApi' | 'tradingGatewayApi'>,
    useGateway: boolean,
): string {
    return useGateway && config.tradingGatewayApi ? config.tradingGatewayApi : config.tradingApi;
}
